module.exports = __webpack_public_path__ + "static/media/photo-user.2a5ce4c8.svg";